import { useSyncExternalStore } from 'react'

const PHONE_QUERY = '(max-width: 640px)'

function subscribe(onChange: () => void) {
  const media = window.matchMedia(PHONE_QUERY)
  media.addEventListener('change', onChange)
  return () => media.removeEventListener('change', onChange)
}

/** Si la pantalla es de teléfono; el mismo umbral que las reglas de CSS del dashboard. */
export function usePhoneViewport(): boolean {
  return useSyncExternalStore(subscribe, () => window.matchMedia(PHONE_QUERY).matches, () => false)
}
